import * as React from 'react';
import { Link } from 'react-router-dom';
import { default as NavDrawerButton } from './navDrawerButton/navDrawerButton';

import './navToolbar.css'

export interface INavToolBarProps {
  isDrawerOpen: boolean
  toggleDrawer: () => void
}

export default class NavToolBar extends React.PureComponent<INavToolBarProps, any> {

public render() {
  return (
    <header className="toolbar">
      <nav className="toolbar__navigation">
        <div className="spacer"/>
        <div className="" onClick={this.props.toggleDrawer}>
          <NavDrawerButton
            ToggleButton={this.props.toggleDrawer}/>
        </div>
        <div className="toolbar__navigation-items">
          <ul>
            <li>
              <Link to='/'>Home</Link>
            </li>
            <li>
              <Link to='/photos/events'>Events</Link>
            </li>
            <li>
              <Link to='/photos/groups'>Groups</Link>
            </li>
            <li>
              <Link to='/photos/lifestyle'>Lifestyle</Link>
            </li>
            <li>
              <Link to='/photos/portraits'>Portraits</Link>
            </li>
            <li>
              <Link to='/photos/published'>Published</Link>
            </li>
            <li>
              <Link to='/profile'>Profile</Link>
            </li>
          </ul>
        </div>
    <div className='logo' />

      </nav>
    </header>
  );
  }
}



// WEBPACK FOOTER //
// ./src/bundles/common/components/navToolbar/navToolbar.tsx